/**
 * Configuração do Cognito.
 *
 * Pool e client **não são segredo**: são identificadores públicos, projetados para ficar no cliente.
 * O que nunca pode ir para o código é credencial da AWS — e não vai, porque o painel não fala com a
 * AWS diretamente, apenas com o Cognito e com a nossa API.
 *
 * Os valores vêm de variável de ambiente com fallback para o pool existente, para que o Codespaces
 * funcione sem configuração adicional. No Amplify, definir as variáveis explicitamente.
 */

import { Amplify } from 'aws-amplify';

/** Pool de produção, reaproveitado do legado conforme o requisito 2. */
const PADRAO = {
  userPoolId: 'us-east-2_fUJ9fjgTg',
  userPoolClientId: '2rvnaul1l33lqi9qfe7k6ue35d',
} as const;

export interface ConfiguracaoCognito {
  readonly userPoolId: string;
  readonly userPoolClientId: string;
}

/** Lê a configuração do ambiente, caindo para o pool existente quando ausente. */
export function lerConfiguracao(
  ambiente: Readonly<Record<string, string | undefined>> = import.meta.env,
): ConfiguracaoCognito {
  return {
    userPoolId: ambiente.VITE_COGNITO_USER_POOL_ID ?? PADRAO.userPoolId,
    userPoolClientId: ambiente.VITE_COGNITO_CLIENT_ID ?? PADRAO.userPoolClientId,
  };
}

/**
 * Domínio corporativo exigido no cadastro.
 *
 * A validação real acontece no servidor, pelo trigger `verify-emaster-email` do pool. Repetir aqui
 * serve para dar erro imediato no formulário, não para proteger — o cliente nunca é a barreira.
 */
export const DOMINIO_CORPORATIVO = '@emaster.info';

let configurado = false;

/** Configura o Amplify uma única vez. Chamar mais de uma vez é inofensivo. */
export function configurarCognito(config: ConfiguracaoCognito = lerConfiguracao()): void {
  if (configurado) return;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        signUpVerificationMethod: 'code',
        loginWith: { email: true },
      },
    },
  });

  configurado = true;
}
